import { render } from "./InviteImgUpload.vue?vue&type=template&id=d996b7ee&scoped=true"
import script from "./InviteImgUpload.vue?vue&type=script&lang=js"
export * from "./InviteImgUpload.vue?vue&type=script&lang=js"

import "./InviteImgUpload.vue?vue&type=style&index=0&id=d996b7ee&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d996b7ee"]])

export default __exports__